import React, { createContext, useContext } from "react";

import { Mortgage } from "../../model/MortgageExtensionModel";
import { MortgageAction, MortgageActionType } from "./Actions";
import { handleSetMortgageAction, handleSetNewMortgageAction } from "./Handlers";

/**
 * The state of the "chosen" mortgage, the one that is being extended.
 * Shared across multiple screens and components.
 */
export interface MortgageState {
    mortgage?: Mortgage;
    newMortgage?: Mortgage;
}

export const mortgageInitialState: MortgageState = {
    mortgage: undefined,
    newMortgage: undefined,
};

export const MortgageStateContext = createContext(mortgageInitialState);
export const MortgageDispatchContext = createContext((() => 0) as React.Dispatch<MortgageAction<any>>);

export const useMortgageDispatch = () => {
    return useContext(MortgageDispatchContext);
};

export const useMortgageState = () => {
    return useContext(MortgageStateContext);
};

export const mortgageReducer = (state: MortgageState, action: MortgageAction<any>): MortgageState => {
    switch (action.type) {
        case MortgageActionType.SetMortgage:
            return handleSetMortgageAction(state, action);
        case MortgageActionType.SetNewMortgage:
            return handleSetNewMortgageAction(state, action);
        default:
            return state;
    }
};
